import React from "react";
import { Modal, Image } from "react-bootstrap";

const PostPreviewModal = ({ show, onHide, listing }) => {
  if (!listing) return null;

  return (
    <Modal show={show} onHide={onHide} centered size="md">
      <Modal.Body className="p-4">
        <div className="d-flex align-items-center mb-2">
          <Image
            src={listing.userImage || "/assets/default_user.png"}
            roundedCircle
            width={40}
            height={40}
            className="me-2"
          />
          <div>
            <strong>Jacari Boboye</strong>
            {/* <strong>{listing.userName}</strong> */}
            <div className="text-muted" style={{ fontSize: "0.85rem" }}>
                5h ago
              {/* {listing.timeAgo} */}
            </div>
          </div>
        </div>

        {/* <p>{listing.text}</p> */}
        <p>Your post text goes here</p>
        

        <div
          className="d-flex border rounded p-2"
          style={{ overflow: "hidden" }}
        >
          <Image
            // src={listing.previewImage}
            
            src="/assets/temp_url_img.jpg"
            width={100}
            height={100}
            className="rounded me-2"
            style={{ objectFit: "cover" }}
          />
          <div>
            {/* <h6 className="mb-1">{listing.title}</h6> */}
            <h6 className="mb-1">Explore the world to experience the beauty of nature</h6>
            
            <p className="mb-1 text-muted" style={{ fontSize: "0.85rem" }}>
              {/* {listing.description} */}
              Paste your link, get instant insights. It's that easy. We turn your ChatGPT links into live previews.
            </p>
            <span className="text-primary" style={{ fontSize: "0.85rem" }}>
                https://www.chattrack.io
              {/* {listing.link} */}
            </span>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PostPreviewModal;
